const Email = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-id="treeNode_emails_26AssetIcon"
    className="spectrum-Icon_368b34 spectrum-Icon--sizeS_368b34 TreeIconWrapper spectrum-Icon_e2d99e"
    focusable="false"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    fill={'rgb(105, 123, 144)'}
  >
    <defs>
      <symbol id="icon-meue-email" viewBox="0 0 20 20">
        <path d="M9.946 11.155l9.946-7.472v-.829a.634.634 0 00-.622-.644H.622A.634.634 0 000 2.855v.812zm3.745-1.231l6.2 4.645v-9.3z"></path>
        <path d="M12.635 10.718l-1.976 1.49a1.2 1.2 0 01-1.426 0l-2-1.5L0 16.061v.976a.633.633 0 00.622.644H19.27a.633.633 0 00.622-.644v-.879zm-6.466-.806L0 5.256v9.218z"></path>
      </symbol>
    </defs>
    <use xlinkHref="#icon-meue-email" fill="#697B90"></use>
  </svg>
);

export default Email;
